import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["screensSelect", "loopsSelect"]
  static values = { 
    profileCachedSlug: { type: String, default: null }
  }

  dropDownChanged() {
    if (!this.profileCachedSlugValue) return;

    let screen_cached_slug = this.screensSelectTarget.options[ this.screensSelectTarget.selectedIndex ].value;
    let loop_cached_slug = this.loopsSelectTarget.options[ this.loopsSelectTarget.selectedIndex ].value;

    let url = `/profiles/${this.profileCachedSlugValue}/loop_preview/${loop_cached_slug}?screen=${screen_cached_slug}`;
    window.open( url, '_self');
  };

}